<template>
  <div id="wrapper" :class="{ 'sidebar-toggled': !sidebarOpen }">
    <!-- Sidebar -->
    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar"
      :class="{ 'toggled': !sidebarOpen }">
      <router-link to="/" class="sidebar-brand d-flex align-items-center justify-content-center"
        style="background-color: #95abec">
        <div class="d-flex justify-content-center w-100">
          <img class="fas" src="../../../assets/img/cropped-logo_lys.png" />
        </div>
      </router-link>

      <!-- Indicador de sidebar fechada -->
      <div v-if="!sidebarOpen" class="sidebar-closed-indicator">
        <button @click="toggleSidebar" class="btn btn-primary btn-sm">
          <i class="fa fa-bars"></i>
        </button>
      </div>

      <hr class="sidebar-divider my-0" />

      <div class="sidebar-heading fs-5 mb-5">Ambientes</div>

      <template v-if="is_admin">
        <SidebarMenu id="collapseNewsLetter" title="Novidades" icon="fa-folder" category="news_letter"
          :routes="routes" />
        <SidebarMenu id="collapseComercial" title="Comercial" icon="fa-folder" category="comercial" :routes="routes" />
        <SidebarMenu id="collapseMetodologia" title="Metodologia" icon="fa-folder" category="metodologia"
          :routes="routes" />
      </template>

      <SidebarMenu id="collapsePages" title="Interação" icon="fa-folder" category="interacao" :routes="routes" />
    </ul>
    <!-- End of Sidebar -->

    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">
      <!-- Main Content -->
      <div id="content">
        <!-- Topbar -->
        <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
          <button @click="toggleSidebar" class="btn btn-link rounded-circle mr-3 sidebar-toggle-btn"
            :title="sidebarOpen ? 'Ocultar Menu' : 'Mostrar Menu'" :class="{ 'active': !sidebarOpen }">
            <i :class="sidebarOpen ? 'fa fa-bars' : 'fa fa-chevron-right'"></i>
          </button>

          <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown no-arrow">
              <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{ name_user }}</span>
                <img class="img-profile rounded-circle" src="../../../assets/img/undraw_profile.svg" />
              </a>
              <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                <a class="dropdown-item">
                  <i class="bi bi-person-check" style="font-size: 1.3rem; color: #198754;"></i>
                  {{ email_user }}
                </a>
                <router-link to="/profile" class="dropdown-item">
                  <i class="bi bi-eye" style="font-size: 1.1rem;"></i>
                  Perfil
                </router-link>
                <a class="dropdown-item" style="cursor: pointer;" data-toggle="modal" data-target="#configuracao">
                  <i class="bi bi-gear" style="font-size: 1.1rem;"></i>
                  Configurações
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" style="cursor: pointer;" @click="logout">
                  <i class="bi bi-power" style="font-size: 1rem; color: red;"></i>
                  Sair
                </a>
              </div>
            </li>
          </ul>
        </nav>
        <!-- End of Topbar -->

        <!-- Configuração Modal -->
        <ModalConfiguracao v-if="configurations" :configurations="configurations" :selectedClient="selectedClient"
          @update:selectedClient="selectedClient = $event" @save="saveConfigurations" />

        <!-- Router View para carregar os componentes das rotas -->
        <div class="container-fluid">
          <div class="row">
            <keep-alive include="chat,tree,tree-list,cadastro,profile">
              <transition name="pagina">
                <router-view></router-view>
              </transition>
            </keep-alive>
          </div>
        </div>

        <!-- Alert System -->
        <AlertSystem ref="alertSystem" />
      </div>
      <!-- End of Main Content -->

      <!-- Footer -->
      <footer class="sticky-footer bg-white">
        <div class="container my-auto">
          <div class="copyright text-center my-auto">
            <span>&copy; Lys Academy</span>
          </div>
        </div>
      </footer>
      <!-- End of Footer -->
    </div>
  </div>
</template>

<script>
  import { useCookies } from "vue3-cookies";
  import { http } from "../../../http";
  import SidebarMenu from "../SidebarMenu.vue";
  import ModalConfiguracao from "../ModalConfiguracao.vue";
  import AlertSystem from "../AlertSystem.vue";
  import "../../../assets/css/sidebar-toggle.css";

  export default {
    components: { SidebarMenu, ModalConfiguracao, AlertSystem },

    data() {
      return {
        routes: [
          { path: "/painel/newsletter", categoria: "news_letter", titulo: "Newsletter" },
          { path: "/painel/biblioteca-lys", categoria: "news_letter", titulo: "Biblioteca Lys" },
          { path: "/painel/chat", categoria: "interacao", titulo: "Chat Tutor" },
          { path: "/painel/curated-list", categoria: "interacao", titulo: "Curadoria de Conteúdo" },
          { path: "/painel/client", categoria: "comercial", titulo: "Carteira de Clientes" },
          { path: "/painel/enrollments-information", categoria: "comercial", titulo: "Informações dos Alunos" },
          { path: "/painel/push-batches-information", categoria: "comercial", titulo: "Push Batches" },
          { path: "/painel/messages-information", categoria: "comercial", titulo: "Informações das Mensagens" },
          { path: "/painel/metodologia", categoria: "metodologia", titulo: "Controles" },
          { path: "/painel/certificate-generator", categoria: "metodologia", titulo: "Gerador de Certificados" },
        ],
        name_user: "",
        email_user: "",
        is_admin: false,
        configurations: null,
        selectedClient: null,
        sidebarOpen: true, // Estado inicial da sidebar
      };
    },

    mounted() {
      this.initializePainel();

      // Registrar o AlertSystem globalmente
      this.$nextTick(() => {
        if (this.$refs.alertSystem) {
          this.$registerAlertSystem(this.$refs.alertSystem);
        }
      });
    },

    methods: {
      initializePainel() {
        const firstName = localStorage.getItem("first_name");
        const lastName = localStorage.getItem("last_name");
        const email = localStorage.getItem("email");
        const isAdmin = localStorage.getItem("is_admin");

        if (firstName && lastName && email) {
          this.name_user = `${firstName} ${lastName}`;
          this.email_user = email;
          this.is_admin = JSON.parse(isAdmin || "false");

          // Carregar estado da sidebar do localStorage
          const savedSidebarState = localStorage.getItem('sidebarOpen');
          if (savedSidebarState !== null) {
            this.sidebarOpen = savedSidebarState === 'true';
          }

          this.getConfigurations();
        } else {
          this.logout();
        }
      },

      logout() {
        useCookies().cookies.remove("user_session");
        useCookies().cookies.remove("set_user_info");
        localStorage.clear();
        this.$router.replace("/login");
      },

      async getConfigurations() {
        if (!this.configurations) {
          const payload = { token: localStorage.getItem("user_session") };
          await http.post("return-list-client/", payload)
            .then(response => {
              this.configurations = response.data;
            })
            .catch(error => console.error(error));
        }
      },

      saveConfigurations() {
        if (!this.selectedClient) return;

        const payload = {
          token: localStorage.getItem("user_session"),
          client: parseInt(this.selectedClient),
          is_report_enabled: this.configurations.is_report_enabled,
        };

        http.post("save-configurations/", payload)
          .then(response => console.log(response.data))
          .catch(error => console.error(error))
          .finally(() => this.getConfigurations());
      },

      toggleSidebar() {
        this.sidebarOpen = !this.sidebarOpen;
        // Salvar estado no localStorage para persistir entre sessões
        localStorage.setItem('sidebarOpen', this.sidebarOpen.toString());
      },
    },
  };
</script>

<style scoped>
  a {
    text-decoration: none !important;
  }

  /* Estilos para sidebar colapsável */
  .sidebar-toggle-btn {
    transition: all 0.3s ease;
    z-index: 1000;
  }

  .sidebar-toggle-btn:hover {
    background-color: #f8f9fa;
    transform: scale(1.1);
  }

  .sidebar-toggle-btn.active {
    background-color: #e3f2fd;
    color: #1976d2;
  }

  .sidebar-toggle-btn.active:hover {
    background-color: #bbdefb;
  }

  /* Animações da sidebar */
  .sidebar {
    transition: all 0.3s ease;
    width: 14rem;
  }

  .sidebar.toggled {
    transform: translateX(-100%);
    width: 0 !important;
    min-width: 0 !important;
    margin-left: 0 !important;
  }

  /* Ajustes para o content wrapper quando sidebar está fechada */
  #content-wrapper {
    transition: all 0.3s ease;
  }

  .sidebar-toggled #content-wrapper {
    margin-left: 0 !important;
    width: 100% !important;
  }

  /* Remover completamente o espaço da sidebar quando fechada */
  .sidebar-toggled .sidebar {
    width: 0 !important;
    min-width: 0 !important;
    overflow: hidden;
  }

  /* Garantir que o wrapper ocupe toda a largura */
  .sidebar-toggled #wrapper {
    width: 100% !important;
  }

  .sidebar-toggled #content {
    width: 100% !important;
    margin-left: 0 !important;
  }

  /* Reset completo de margens e paddings quando sidebar está fechada */
  .sidebar-toggled .container-fluid {
    padding-left: 15px !important;
    padding-right: 15px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  /* Forçar remoção de qualquer espaço da sidebar */
  .sidebar-toggled * {
    box-sizing: border-box;
  }

  .sidebar-toggled .sidebar {
    position: absolute !important;
    left: -100% !important;
  }

  /* Indicador de sidebar fechada */
  .sidebar-closed-indicator {
    position: fixed;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 0 8px 8px 0;
    padding: 10px 5px;
  }

  .sidebar-closed-indicator button {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Responsividade */
  @media (max-width: 768px) {
    .sidebar {
      transform: translateX(-100%);
    }

    .sidebar.toggled {
      transform: translateX(0);
    }

    .sidebar-toggled #content-wrapper {
      margin-left: 0 !important;
    }

    .sidebar-closed-indicator {
      display: none;
    }
  }
</style>
